export default __webpack_public_path__ + "static/media/BeVietnam-Bold.17717f61.ttf";